import {Component, Inject, OnInit} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ProjectConstants} from '../../project-constants';
import * as servers from '../../../services/api/servers';
import * as toastr from 'toastr';
import {urls} from '../../../services/api/urls';
import {GeneralServicesImplService} from '../../../services/general-services-impl.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {COMMA, ENTER, SPACE, SEMICOLON} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

@Component({
  selector: 'app-dialog-send-email',
  templateUrl: './dialog-send-email.component.html',
  styleUrls: ['./dialog-send-email.component.scss']
})
export class DialogSendEmailComponent extends GeneralServicesImplService implements OnInit {

  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes = [ENTER, COMMA, SPACE, SEMICOLON];
  wrongEmailAddress = false;

  baseUrl: string = servers.apiUrl + urls.email;

  emailToList = [];
  emailTo = '';
  emailSubject = '';
  emailBody = '';

  filter: any;
  currentBaseUrl: any;
  isComparing: boolean;
  isGrouped: boolean;

  constructor(private httpClient: HttpClient,
              public dialogRef: MatDialogRef<DialogSendEmailComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(httpClient);
  }

  ngOnInit() {
    this.filter = this.data.filter ? this.data.filter : undefined;
    this.currentBaseUrl = this.data.currentBaseUrl ? this.data.currentBaseUrl : undefined;
    this.isComparing = this.data.isComparing ? this.data.isComparing : false;
    this.isGrouped = this.data.isGrouped ? this.data.isGrouped : false;
  }

  send() {
    let concatEmail = '';
    concatEmail = this.emailToList.join(',');
    if (concatEmail !== '') {
      let url = this.currentBaseUrl + this.LINKS.SEND_EMAIL;
      if (this.isComparing) {
        url = this.currentBaseUrl + this.LINKS.SEND_COMPARISON_EMAIL;
      }
      const body = {
        filter: this.filter,
        emailList: {
          emailReceiver: concatEmail,
          emailSubject: this.emailSubject,
          emailBody: this.emailBody
        }
      };
      let param: HttpParams = new HttpParams();
      param = param.set('isGrouped', this.isGrouped.toString());
      const header = ProjectConstants.returnGeneralHeader();
      return this.httpClient.post( url, body, {headers: header, responseType: 'json', params: param})
        .pipe(
          // map (data => data) da inserire gestione errori
        ).subscribe((res: any[]) => {
          if (res.length === 0) {
            toastr.success('Email successfully sent.', 'Success!');
            this.dialogRef.close();
          } else {
            const errorEmails: string[] = [];
            res.forEach(email => errorEmails.push(email.emailReceiver));
            toastr.error('Problem sending email with the following addresses: ' + errorEmails.join('<br>'), 'Error!');
          }
        }, err => {
          console.log(err);
        });
    } else {
      toastr.error('At least one email must be inserted.', 'No email address!');
    }
  }

  close() {
    this.dialogRef.close();
  }

  add(event: MatChipInputEvent): void {
    if (event.value) {
      if (this.validateEmail(event.value)) {
        this.emailToList.push(event.value);
        this.wrongEmailAddress = false;
      } else {
        this.wrongEmailAddress = true;
        toastr.error('The email address that you entered is not correct, please try again.', 'Wrong email address!');
      }
    }
    if (event.input) {
      event.input.value = '';
    }
  }

  private validateEmail(email) {
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase().trim());
  }

  remove(email: string): void {
    const index = this.emailToList.indexOf(email);
    if (index >= 0) {
      this.emailToList.splice(index, 1);
    }
  }



}
